import { render, staticRenderFns } from "./Reasons.vue?vue&type=template&id=14de3e9f&scoped=true"
import script from "./Reasons.vue?vue&type=script&lang=js"
export * from "./Reasons.vue?vue&type=script&lang=js"
import style0 from "./Reasons.vue?vue&type=style&index=0&id=14de3e9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14de3e9f",
  null
  
)

export default component.exports